{
  "DeleteReminder": "Supprimer le rappel",
  "DismissAlert": "Ignorer",
  "DismissAllReminders": "Rejeter tous les rappels",
  "DismissReminder": "Rejeter le rappel",
  "EditReminder": "Modifier le rappel",
  "RemindMe15Min": "Me le rappeler dans 15 minutes",
  "RemindMe5Min": "Me le rappeler dans 5 minutes",
  "RemindMe60Min": "Me le rappeler dans une heure",
  "RemindMeTomorrow": "Me le rappeler demain",
  "Reminder": "Rappel",
  "Reminders": "Rappels",
  "Snooze": "Me le rappeler"
}
